let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("8tI7B")]).then(() => parcelRequire('defwj'));